module.exports = __webpack_public_path__ + "assets/img/home-selected-report-light-en.5860dfca.png";